import { TenantRole } from 'api/endpoints/tenants';

export enum UserRole {
  Admin = 'admin',
  User = 'user',
  ViewOnlyUser = 'view_only_user',
}

const USER_ROLE = {
  ADMIN: UserRole.Admin,
  USER: UserRole.User,
  VIEWONLY_USER: UserRole.ViewOnlyUser,
} as const;

const TENANT_ROLE = {
  ADMIN: 'tenant_admin',
  MANAGER: 'tenant_manager',
  USER: 'tenant_user',
} as const;

const SYSTEM_ROLE_SHORT = {
  [USER_ROLE.ADMIN]: 'OA',
};

const SYSTEM_ROLE_FULL: Record<UserRole, string> = {
  [USER_ROLE.ADMIN]: 'Organization Admin',
  [USER_ROLE.USER]: 'User',
  [USER_ROLE.VIEWONLY_USER]: 'View-Only User',
};

const TENANT_ROLE_SHORT: Record<TenantRole, string> = {
  [TENANT_ROLE.ADMIN]: 'A',
  [TENANT_ROLE.MANAGER]: 'M',
  [TENANT_ROLE.USER]: 'U',
};

const TENANT_ROLE_FULL: Record<TenantRole, string> = {
  [TENANT_ROLE.ADMIN]: 'Tenant admin',
  [TENANT_ROLE.MANAGER]: 'Tenant manager',
  [TENANT_ROLE.USER]: 'Tenant user',
};

const ACCESSIBLE_ROLES = {
  ALL: [TENANT_ROLE.USER, TENANT_ROLE.MANAGER, TENANT_ROLE.ADMIN],
  MANAGERS: [TENANT_ROLE.MANAGER, TENANT_ROLE.ADMIN],
  ADMIN: [USER_ROLE.ADMIN],
};

export {
  TENANT_ROLE,
  TENANT_ROLE_FULL,
  TENANT_ROLE_SHORT,
  USER_ROLE,
  SYSTEM_ROLE_FULL,
  SYSTEM_ROLE_SHORT,
  ACCESSIBLE_ROLES,
};
